import { Link } from 'react-router-dom';
import AnimeCard from '@/components/feature/AnimeCard';
import { latestAnime } from '@/mocks/anime';

export default function LatestSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-1">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">每日更新，精彩不断</p>
          </div>
          <Link
            to="/category/mitao"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4" data-product-shop="">
          {latestAnime.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>
      </div>
    </section>
  );
}